import { BRAND } from '@rydres/shared';
import { Card, PlacesEditor } from '@rydres/ui';
import { geoApi } from '../lib/api.js';
import { Shell, useRiderGate } from './Passenger.js';

/** rydres.com/me/services: the saved places, the buttons that fill the origin and destination of a ride. */
export function ServicesPage() {
  const { p, gate } = useRiderGate('Services', `Sign in with the mobile number you book with to keep your places for quick ride requests with your ${BRAND.name} drivers.`);
  if (gate) return gate;
  const me = p.me!;
  return (
    <Shell>
      <h1 className="text-2xl font-black">Services</h1>
      <Card title="Your places" info="One tap fills the origin or destination when you ask for a ride. Your places are private, except your first home address, which drivers you share your details with can see.">
        <PlacesEditor places={me.places} onSave={p.savePlaces} geo={geoApi} homeNote="Drivers you share your details with see this address." />
      </Card>
    </Shell>
  );
}
